<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'
           v-loading='loadingStaus'
           :element-loading-text='loadingText'>

        <el-row :gutter='48' style='padding: 10px'>
          <el-form ref='articleForm' :model='formData' :rules='rules'  label-suffix='：'>
            <el-col :span='16' class='content-left'>
              <el-form-item label='网站名称' prop='web_name'>
                <el-input v-model='formData.web_name' placeholder='比如：星象仪' clearable></el-input>
              </el-form-item>
              <el-form-item label='系统版权备案信息' prop='copyright'>
                <el-input v-model='formData.copyright' placeholder='比如：Copyright 2021~2026 杭州朝前网络科技有限公司 | 备案号：浙ICP备19028148号-2 ' clearable></el-input>
              </el-form-item>
              <!--              <el-form-item label='统计代码' prop='analytics'>-->
              <!--                <el-input :rows='6' type='textarea' v-model='formData.analytics'></el-input>-->
              <!--              </el-form-item>-->
              <!--              <el-form-item label='SEO标题' prop='seo_title'>-->
              <!--                <el-input v-model='formData.seo_title'></el-input>-->
              <!--              </el-form-item>-->
              <!--              <el-form-item label='SEO关键词' prop='seo_keywords'>-->
              <!--                <el-input v-model='formData.seo_keywords'></el-input>-->
              <!--              </el-form-item>-->
              <!--              <el-form-item label='SEO描述' prop='seo_description'>-->
              <!--                <el-input :rows='6' type='textarea' v-model='formData.seo_description'></el-input>-->
              <!--              </el-form-item>-->
              <!--              <div style='display: flex;flex-direction: row;gap: 10px'>-->
              <!--                <el-form-item label='刊例说明文章ID'>-->
              <!--                  <el-input v-model='formData.plc_article_id' placeholder='刊例调整说明文章ID'></el-input>-->
              <!--                </el-form-item>-->
              <!--                <el-form-item label='服饰选品规则文章ID' >-->
              <!--                  <el-input v-model='formData.article_id_selection' placeholder='服饰选品规则文章ID'></el-input>-->
              <!--                </el-form-item>-->
              <!--              </div>-->

              <!--              <el-form-item label='签约部门' prop='seo_keywords'>-->
              <!--                <el-tag-->
              <!--                  type='success'-->
              <!--                  :key='tag'-->
              <!--                  v-for='tag in signatory'-->
              <!--                  closable-->
              <!--                  style='margin-right: 10px'-->
              <!--                  :disable-transitions='false'-->
              <!--                  @close='handleClose(tag)'>-->
              <!--                  {{ tag }}-->
              <!--                </el-tag>-->

              <!--                <el-button type='text' v-show='!dialogVisible' class='button-new-tag' size='small' @click='showInput'>+-->
              <!--                  新部门-->
              <!--                </el-button>-->

              <!--              </el-form-item>-->
              <!--              <el-form-item>-->
              <!--                <el-button @click="initTemplate">初始化审批模板</el-button>-->
              <!--              </el-form-item>-->
              <div style='border: 1px #f2f2f2 solid;margin-top: 10px;padding: 10px'>
                <el-tabs :tab-position='tabPosition' style='height: auto;'>
                  <!--                  <el-tab-pane label='钉钉配置'>-->
                  <!--                    <el-row>-->
                  <!--                      <el-col :span='18'>-->
                  <!--                        <el-form :model='config.dingTalk' :inline='false' label-width='100px' :label-position='labelPosition'>-->
                  <!--                          <el-form-item :label='`${item.label}：`' v-for='(item,field) in config.dingTalk' :key='field'>-->
                  <!--                            &lt;!&ndash;                  <el-input v-model='config.dingTalk[field].value' :placeholder='item.label' clearable></el-input>&ndash;&gt;-->
                  <!--                            <el-input style='width: 400px' v-model='item.value' :placeholder='item.label'-->
                  <!--                                      clearable></el-input>-->
                  <!--                          </el-form-item>-->
                  <!--                        </el-form>-->
                  <!--                      </el-col>-->
                  <!--                    </el-row>-->

                  <!--                  </el-tab-pane>-->
                  <el-tab-pane label='签约配置'>
                    <div style='padding: 10px'>
                      <el-form-item label='签约部门'>
                        <el-tag
                          type='success'
                          :key='tag'
                          v-for='tag in signatory'
                          closable
                          :disable-transitions='false'
                          @close='handleClose(tag)'>
                          {{ tag }}
                        </el-tag>

                        <el-button type='text' v-show='!dialogVisible' style='margin-left: 10px' class='button-new-tag' size='small' @click='showInput'>+
                          新部门
                        </el-button>

                      </el-form-item>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label='刊例配置'>
                    <div style='padding: 10px'>
                      <el-form-item label='刊例说明文章ID'>
                        <el-input v-model='formData.plc_article_id' placeholder='红人刊例提报录入底下的说明文章内容' clearable></el-input>
                      </el-form-item>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label='选品配置'>
                    <div style='padding: 10px'>
                      <el-form-item label='服饰选品规则文章ID' >
                        <el-input v-model='formData.article_id_selection' placeholder='服饰选品规则文章ID' clearable></el-input>
                      </el-form-item>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label='应用配置'>
                    <div style='padding: 10px'>
                      <div class='app-config-tip'>
                        为各业务模块关联「系统管理 → 应用管理」中已启用的应用（按应用编码关联），关联后业务端按模块读取对应的应用配置。
                      </div>
                      <el-form-item v-for='item in appModules' :key='item.code' :label='item.name'>
                        <el-select v-model='appConfig[item.code].mini_app_id'
                                   placeholder='未关联'
                                   clearable
                                   filterable
                                   style='width: 340px'>
                          <el-option v-for='app in miniAppOptions'
                                     :key='app.id'
                                     :value='app.id'
                                     :label='formatAppOptionLabel(app)' />
                        </el-select>
                        <span class='app-config-desc'>{{ item.description }}</span>
                      </el-form-item>
                      <el-form-item v-if='!appModules.length'>
                        <span class='app-config-desc'>暂无可配置的业务模块</span>
                      </el-form-item>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-col>
            <el-col class='content-right' :span='8'>
              <el-form-item label='站点LOGO' prop='web_logo'>
                <ApeUploader :limit='1' @handleUploadSuccess='handleUploadSuccess'
                             @handleUploadRemove='handleUploadRemove' :upload-file-list='uploadFileList'></ApeUploader>
              </el-form-item>
              <div class='right-button'>
                <el-button size='medium' type='primary' :disabled='loadingStaus' @click='saveConfirm'
                           v-if="userPermissions.indexOf('setting_site') != -1">保存
                </el-button>
              </div>
            </el-col>
          </el-form>
        </el-row>


      </div>
    </PageHeaderLayout>

    <el-dialog
      title='请选择签约数据来源部门'
      :visible.sync='dialogVisible'
      width='30%'
      :before-close='handleConfirm'>
      <div style='width: 100%'>
        <el-row>
          <el-col :span='1.5'>
            部门中选择：
          </el-col>
          <el-col :span='1.5'>
            <CompanySelect :multiple='true' :valueType="'name'" @handleSelect='handleChange' />

          </el-col>

        </el-row>
        <br>
        <el-col :span='1.5'>
          自定义输入(使用 "," 作为分隔号)：
        </el-col>
        <el-col :span='1.5'>
          <el-input v-model='inputValue' @change='inputInit' style='width: 200px' size='mini'></el-input>
        </el-col>
      </div>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='dialogVisible = false'>取 消</el-button>
        <el-button type='primary' @click='dialogVisible = false'>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeUploader from '@/components/ApeUploader'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'SettingSite',
  components: {
    PageHeaderLayout,
    ApeUploader
  },
  data() {
    return {
      hearTitle: '基本设置',
      tabPosition: 'top',
      labelPosition: 'right',
      loadingStaus: true,
      loadingText: '玩命提交中……',
      // 站点基本信息表单结构
      formData: {},
      // 已上传文件列表
      uploadFileList: [],
      // 站点基本信息规则
      rules: {
        web_name: [
          { required: true, message: '输入站点名称', trigger: 'blur' }
        ]
      },
      signatory: [],
      dialogVisible: false,
      options: [],
      value: [],
      inputValue: '',
      // 应用配置：可选的业务模块（后端 App\Constants\SiteAppEnum 维护）
      appModules: [],
      // 应用配置：业务模块 → 关联的应用（应用管理 mini_apps）
      appConfig: {},
      // 应用管理-已启用的应用下拉
      miniAppOptions: [],
      // 应用管理-应用类型字典（type => 文案）
      miniAppTypeMap: {},
      config: {
        dingTalk: {
          title: { label: '应用名称', value: '星象仪' },
          corp_id: { label: '唯一标识', value: '' },
          agent_id: { label: '应用ID', value: '' },
          app_key: { label: '应用Key', value: '' },
          app_secret: { label: '应用secret', value: '' },
          aes_key: { label: '订阅es_key', value: '' },
          token: { label: '订阅token', value: '' }
        }
      }


    }
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  methods: {
    inputInit() {
      if (this.inputValue != '') {
        const data = this.inputValue.split(',')
        this.signatory = [...this.signatory, ..._.difference(data, this.signatory)]
      }
    },
    async showInput() {
      await this.getList()
      this.dialogVisible = true
      this.value = this.signatory

      // this.$nextTick(() => {
      //   this.$refs.saveTagInput.$refs.input.focus()
      // })
    },
    handleChange(selectArr) {
      this.signatory = selectArr
      return selectArr
    },
    async getList() {
      const { list } = await this.$api.getDepartmentAll()
      this.options = list.map((i) => {
        return i.parent_id == 1 ? i : false
      }).filter(Boolean)
    },
    handleConfirm() {

      this.dialogVisible = false
    },
    // 应用配置：加载应用管理中「已启用」的应用下拉及应用类型字典
    async initMiniAppData() {
      try {
        const [appList, meta] = await Promise.all([
          this.$api.getMiniAppOptions(),
          this.$api.getMiniAppMeta()
        ])
        const typeMap = {}
        const types = (meta && meta.types) ? meta.types : []
        types.forEach((item) => {
          typeMap[item.id] = item.text
        })
        this.miniAppTypeMap = typeMap
        this.miniAppOptions = appList || []
      } catch (e) {
        this.miniAppOptions = []
      }
      // 已关联但不在启用列表中的应用，补入下拉用于回显
      this.syncMiniAppOptions()
    },
    // 应用配置：初始化「业务模块 → 关联应用」
    initAppConfig(info) {
      const modules = info.app_modules || []
      const config = info.app_config || {}
      const appConfig = {}
      modules.forEach((module) => {
        const item = config[module.code] || {}
        appConfig[module.code] = {
          mini_app_id: item.mini_app_id || null,
          type: item.type || 0,
          code: item.code || '',
          name: item.name || ''
        }
      })
      this.appModules = modules
      this.appConfig = appConfig
      this.syncMiniAppOptions()
    },
    // 应用配置：已关联但（后续）被停用/删除的应用补进下拉，避免回显为裸ID
    syncMiniAppOptions() {
      const options = [...this.miniAppOptions]
      const existIds = options.map((item) => item.id)
      Object.keys(this.appConfig || {}).forEach((module) => {
        const item = this.appConfig[module]
        if (!item || !item.mini_app_id || existIds.indexOf(item.mini_app_id) !== -1) {
          return
        }
        existIds.push(item.mini_app_id)
        options.push({
          id: item.mini_app_id,
          type: item.type,
          name: item.name,
          code: item.code,
          invalid: true
        })
      })
      this.miniAppOptions = options
    },
    // 应用配置：下拉文案（类型 · 应用编码）
    formatAppOptionLabel(app) {
      const typeText = this.miniAppTypeMap[app.type] || ''
      const suffix = [typeText, app.code].filter(Boolean).join(' · ')
      return suffix ? `${app.name}（${suffix}）${app.invalid ? '（已停用或已删除）' : ''}` : `${app.name}${app.invalid ? '（已停用或已删除）' : ''}`
    },

    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['articleForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    handleClose(tag) {
      this.signatory.splice(this.signatory.indexOf(tag), 1)
    },
    // 站点相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true
      this.formData.signatory = this.signatory.toString()
      // 应用配置（业务模块 → 关联应用）
      this.formData.app_config = this.appConfig
      const id = await this.$api.saveSettingSiteInfo(this.formData)
      if (id) {
        this.$notify.success('保存成功！')
        // 重新拉取，回显后端冗余的应用快照（名称/编码/类型）
        await this.initSettingSiteForm()
      }
      this.$nextTick(() => {
        this.loadingStaus = false
      })
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.web_logo = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.web_logo = 0
      this.uploadFileList = fileList
    },
    // 初始化站点基本信息
    async initSettingSiteForm() {
      // 获取站点分类列表
      const { info } = await this.$api.getSettingSiteInfo()
      this.formData = info
      this.signatory = info.signatory.split(',')
      if (info.web_logo_info) {
        this.uploadFileList = [{
          id: info.web_logo_info.id,
          name: info.web_logo_info.title,
          url: info.web_logo_info.full_path
        }]
      }
      // 应用配置（业务模块 → 关联应用）
      this.initAppConfig(info)
    }
  },
  async mounted() {
    this.loadingStaus = true
    try {
      await this.initMiniAppData()
      await this.initSettingSiteForm()
    } finally {
      this.$nextTick(() => {
        this.loadingStaus = false
      })
    }

  }
}
</script>

<style lang='scss'>
.app-config-tip {
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}

.app-config-desc {
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}

.content-left {
  min-height: 640px;
  border-right: 1px solid #e8e8e8;

  .el-cascader {
    display: block;
    width: 320px;
  }
}

.content-right {
  .right-button {
    border-top: 1px solid #e8e8e8e8;
    padding: 12px 12px;
  }

  .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 10px 0;
  }

  .el-form-item__content {
    margin-left: 0 !important;

    .el-checkbox-group {
      margin-top: -12px;
    }
  }
}
</style>
